import styled from 'styled-components';

import {Icon} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';
import {TSpacingSize} from '@edna/components/types';

import {CollapsibleSection as BaseCollapsibleSection} from 'src/components';

export const CollapsibleSection = styled(BaseCollapsibleSection)`
  &:not(:last-child) {
    border: none;
  }
`;

export const Tariffs = styled.div`
  ${mixins.stack({size: '4'})}
  width: 100%;
  margin-top: ${({theme}) => theme.spacing.s2};
`;

export const LeftIcon = styled(Icon)<{indent?: TSpacingSize}>`
  margin-right: ${({theme, indent = '1'}) => theme.spacing[`s${indent}`]};
`;
